<template>
  <common-page-layout>
      <p v-if="business.pwa">{{business.pwa.about}}</p>        
      <p v-if="business && business.pwa && business.pwa.howto">{{business.pwa.howto}}</p>
      <p v-if="business && business.pwa && business.pwa.instructions">{{business.pwa.instructions}}</p>
  </common-page-layout>
</template>

<script>
  import {mapGetters} from "vuex";
  export default {  
    computed: mapGetters(["business"])
  };
</script>



// WEBPACK FOOTER //
// src/components/About.vue